import React from "react";
import { AvatarInterface } from "src/store/mine_craft/avatarsSlice";
import { UserInterface } from "src/store/mine_craft/usersSlice";
import CardImage from "../../../../componets/CardImage";
import { formattedDate } from "../../../../helpers/DateHelpers";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";
import { EntityId } from "@reduxjs/toolkit";
import { setEditId } from "../../../../store/mine_craft/avatarsSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyAvatar } from "../../../../actions/mine_craft/avatarsActions";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import Meta from "../../../mine_craft/Users/_partials/_Meta";

interface propsInterface {
  avatar: AvatarInterface;
  user?: UserInterface | undefined;
}

const Card = ({ avatar, user }: propsInterface) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const formattedCreatedAt = formattedDate(avatar.created_at);

  function onClickEdit(id: EntityId)  {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAvatar(id));

    if (destroyAvatar.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
      setTimeout(() => navigate(0), 1000);
    }

    if (destroyAvatar.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <CardImage
      className={'v-mine_craft-avatars__card'}
      image={avatar.image_url}
      size='medium'
      options={[
        <ButtonEdit key={`edit-${avatar.id}`} onClick={() => onClickEdit(avatar.id)} />,
        <ButtonDestroy key={`destroy-${avatar.id}`} onClick={() => onClickDestroy(avatar.id)} />
      ]}
    >
      {user && <Meta user={user} size='xsmall' />}

      <div className='v-small_text'>
        {formattedCreatedAt && <small>{formattedCreatedAt.date} <small>{formattedCreatedAt.time}</small></small> }
      </div>
    </CardImage>
  )
}

export default Card;
